<!-- SchedulerFilters.vue -->
<template>
	<div class="chip-bar border-right">
		<v-row no-gutters align="center" class="my-2 mx-2">
			<v-col v-for="filter in filterOptions" :key="filter.value" cols="4" class="px-1">
				<v-chip
					class="w-100 justify-center"
					size="small"
					:color="modelValue === filter.value ? 'primary-green' : 'grey-lighten'"
					:variant="modelValue === filter.value ? 'flat' : 'tonal'"
					@click="$emit('update:modelValue', filter.value)"
				>
					{{ filter.label }} ({{ filter.count }})
				</v-chip>
			</v-col>
		</v-row>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	modelValue: string;
	filterOptions: Array<{ label: string; value: string; count: number }>;
}>();

defineEmits(['update:modelValue']);
</script>

<style lang="scss" scoped>
.border-right {
	border-right: 1px solid #eee;
}

.chip-bar {
	width: 100%;
	max-width: 290px; /* maps to var(--sidebar-width) */
}
</style>
